import { render } from "./PregCreate.vue?vue&type=template&id=166e7aae&scoped=true"
import script from "./PregCreate.vue?vue&type=script&lang=js"
export * from "./PregCreate.vue?vue&type=script&lang=js"

import "./PregCreate.vue?vue&type=style&index=0&id=166e7aae&scoped=true&lang=css"
import "./PregCreate.vue?vue&type=style&index=1&id=166e7aae&lang=css"
import "./PregCreate.vue?vue&type=style&index=2&id=166e7aae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166e7aae"]])

export default __exports__